(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[548],{

/***/ 84670:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plasmids",
      function () {
        return __webpack_require__(39099);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78251:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: globalCommon  } = __webpack_require__(31668);
const { de: plasmidsCommon  } = __webpack_require__(91621);
module.exports = {
    ...globalCommon,
    ...plasmidsCommon,
    "plasmids-home": __webpack_require__(15506),
    "section-try-for-free": __webpack_require__(3049)
};


/***/ }),

/***/ 54746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: globalCommon  } = __webpack_require__(31668);
const { en: plasmidsCommon  } = __webpack_require__(91621);
module.exports = {
    ...globalCommon,
    ...plasmidsCommon,
    "plasmids-home": __webpack_require__(73728),
    "section-try-for-free": __webpack_require__(33686)
};


/***/ }),

/***/ 25296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(54746),
    de: __webpack_require__(78251)
};


/***/ }),

/***/ 39099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ plasmids; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/create-and-raise.js
var create_and_raise = __webpack_require__(55161);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/index.js + 1 modules
var PageNavbarSearch = __webpack_require__(59157);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/Main.js
var Main = __webpack_require__(23069);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbarSearch/Sidebar.js
var Sidebar = __webpack_require__(68646);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PlasmidElement/index.js
var PlasmidElement = __webpack_require__(28207);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/index.js + 1 modules
var Breadcrumbs = __webpack_require__(78086);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Breadcrumbs/Item.js
var Item = __webpack_require__(71125);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js + 1 modules
var UList = __webpack_require__(51192);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/AssetsProvider/index.js + 1 modules
var AssetsProvider = __webpack_require__(84154);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Video/Video.js
/* eslint-disable jsx-a11y/media-has-caption */ 




const Video = (param)=>{
    let { isBaseUrl =true , srcMP4 , srcWEBM ="" , poster , controls =false , loop =true , playsInline =true , autoPlay =true , muted =true , preload ="auto" , children =null , className ="" , frame =false , ...props } = param;
    const baseUrl = isBaseUrl ? (0,react.useContext)(AssetsProvider/* default.context */.Z.context) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
        className: (0,classes/* classes */.S)("video", frame && "video--frame", className),
        controls: controls,
        autoPlay: autoPlay,
        loop: loop,
        playsInline: playsInline,
        muted: muted,
        poster: "".concat(baseUrl).concat(poster),
        preload: preload,
        ...props,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                type: "video/mp4",
                src: "".concat(baseUrl).concat(srcMP4)
            }),
            srcWEBM ? /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                type: "video/webm",
                src: "".concat(baseUrl).concat(srcWEBM)
            }) : null,
            children,
            "Your browser does not support the video tag."
        ]
    });
};
Video.propTypes = {
    isBaseUrl: prop_types.bool,
    srcMP4: prop_types.string.isRequired,
    srcWEBM: prop_types.string,
    poster: prop_types.string.isRequired,
    className: prop_types.string,
    controls: prop_types.bool,
    autoPlay: prop_types.bool,
    loop: prop_types.bool,
    playsInline: prop_types.bool,
    preload: (0,prop_types.oneOf)([
        "none",
        "auto",
        "metadata"
    ]),
    muted: prop_types.bool,
    frame: prop_types.bool,
    children: prop_types.node
};
/* harmony default export */ var Video_Video = (Video);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Video/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/index.js + 2 modules
var DiPageHoC = __webpack_require__(74063);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithConditions/index.js
var WithConditions = __webpack_require__(83803);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/NextPageWithServices.js + 5 modules
var NextPageWithServices = __webpack_require__(18092);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/Plasmids/routes/index.js
var routes = __webpack_require__(27404);
// EXTERNAL MODULE: ./src/Plasmids/ui/PageNavbarSearch/index.js
var ui_PageNavbarSearch = __webpack_require__(18570);
// EXTERNAL MODULE: ./src/Plasmids/ui/SectionItems/index.js + 3 modules
var SectionItems = __webpack_require__(97703);
// EXTERNAL MODULE: ./src/Plasmids/ui/BlockAutocomplete/index.js + 4 modules
var BlockAutocomplete = __webpack_require__(87149);
// EXTERNAL MODULE: ./src/Plasmids/utils/plasmid/helpers.js
var helpers = __webpack_require__(80702);
// EXTERNAL MODULE: ./src/Plasmids/services/sgApiConnection.js
var sgApiConnection = __webpack_require__(41674);
// EXTERNAL MODULE: ./src/Plasmids/services/sgApiClient.js + 3 modules
var sgApiClient = __webpack_require__(96373);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/props-resolver.js
var props_resolver = __webpack_require__(77915);
// EXTERNAL MODULE: ./src/Plasmids/providers/getPlasmidSets.js
var getPlasmidSets = __webpack_require__(31927);
;// CONCATENATED MODULE: ./src/Plasmids/resolvers/sets-resolvers.js


/* harmony default export */ var sets_resolvers = ((0,props_resolver/* default */.Z)({
    sets: getPlasmidSets/* default */.Z
}));

// EXTERNAL MODULE: ./src/Plasmids/services/index.js
var services = __webpack_require__(55093);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./src/SectionTryForFree/index.js
var SectionTryForFree = __webpack_require__(98106);
// EXTERNAL MODULE: ./src/AppError/index.js + 10 modules
var AppError = __webpack_require__(38209);
// EXTERNAL MODULE: ./locales/plasmids-home-page/index.js
var plasmids_home_page = __webpack_require__(25296);
var plasmids_home_page_default = /*#__PURE__*/__webpack_require__.n(plasmids_home_page);
;// CONCATENATED MODULE: ./pages/plasmids/index.js







































const PlasmidsHomePage = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("plasmids-home");
    const { sets  } = (0,DiPageHoC/* usePageData */.Vi)();
    const url = (0,react.useMemo)(()=>"https://".concat(routes/* ROUTE_DOMAIN_PROD */.J$).concat(routes/* ROUTE_PLASMIDS */.$b), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        hero: true,
        isBorderBottomNone: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META_TITLE"),
                description: t("META_DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: t("META_TITLE"),
                        description: t("META_DESCRIPTION"),
                        siteName: t("META_SITE_NAME"),
                        articlePublisher: t("META_ARTICLE_PUBLISHER"),
                        locale: t("META_LOCALE"),
                        type: t("META_TYPE"),
                        url: url,
                        image: t("META_IMAGE"),
                        imageSecureUrl: t("META_IMAGE_SECURE"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Author */.ZP.Author, {
                        content: t("META_AUTHOR")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        title: t("META_TITLE"),
                        description: t("META_DESCRIPTION"),
                        card: t("META_TWITTER_CARD"),
                        creator: t("META_TWITTER_CREATOR"),
                        site: t("META_TWITTER_SITE"),
                        image: t("META_TWITTER_IMAGE"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Robots */.ZP.Robots, {
                        content: t("META_ROBOTS")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        children: t("HERO_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        children: t("HERO_DESCRIPTION")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageNavbarSearch/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main/* default */.Z, {
                        children: [
                            t("EXPLORE_OVER_PLASMIDS_INCLUDING"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: ui_PageNavbarSearch/* PageNavbarSearchLink */.J,
                                href: (0,helpers/* routePlasmid */.uT)(routes/* ALIAS_PET_AND_DUET_VECTORS_NOVAGEN */.Bi, routes/* ALIAS_PET_28A_PLUS */.bF),
                                children: "pET-28a(+)"
                            }),
                            ",",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: ui_PageNavbarSearch/* PageNavbarSearchLink */.J,
                                href: (0,helpers/* routePlasmid */.uT)(routes/* ALIAS_BASIC_CLONING_VECTORS */.oc, routes/* ALIAS_PUC19 */.o$),
                                children: "pUC19"
                            }),
                            ",",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: ui_PageNavbarSearch/* PageNavbarSearchLink */.J,
                                href: (0,helpers/* routePlasmid */.uT)(routes/* ALIAS_BASIC_CLONING_VECTORS */.oc, routes/* ALIAS_PBR322 */.Re),
                                children: "pBR322"
                            }),
                            ",",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: ui_PageNavbarSearch/* PageNavbarSearchLink */.J,
                                href: (0,helpers/* routePlasmid */.uT)(routes/* ALIAS_FLUORESCENT_PROTEIN_GENES_AND_PLASMIDS */.nn, routes/* ALIAS_PEGFP_N1 */.aP),
                                children: "pEGFP-N1"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockAutocomplete/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlasmidElement/* PlasmidElementSectionBreadcrumbs */.jM, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: Item/* BreadcrumbItemLink */.A,
                                href: routes/* ROUTE_HOME */.XX,
                                children: t("HOME")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                                children: t("PLASMIDS")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default */.Z, {
                spacing: {
                    py: 6
                },
                isBorderNone: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                        my: true,
                        mx: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                md: 6,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                        sx: {
                                            fontSize: "l",
                                            fontColor: "2"
                                        },
                                        spacing: {
                                            mt: 0
                                        },
                                        children: "Gain Unparalleled Visibility of Your Sequences"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                        spacing: {
                                            ml: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                spacing: {
                                                    my: 3
                                                },
                                                children: "Open sequence files in SnapGene to view features, annotate, clone and use as a reference"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                spacing: {
                                                    my: 3
                                                },
                                                children: "Display enzyme sites, features, primers, ORFs, translations and more on plasmid maps or in detail on the sequence view"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                spacing: {
                                                    my: 3
                                                },
                                                children: "Annotate features on your sequences using SnapGene’s curated feature database or your own custom features"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                spacing: {
                                                    my: 3
                                                },
                                                children: "Add your vector directly into a cloning simulation with all restriction sites and features displayed"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video_Video, {
                                    srcMP4: "/images/snapgene/plasmid-main/plasmidMain.mp4",
                                    poster: "/images/snapgene/plasmid-main/plasmidPoster.png"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionItems/* default */.Z, {
                type: "set",
                title: "Plasmid Sets",
                hasDescription: true,
                colCount: 2,
                items: sets,
                ItemLinkComponent: PlasmidElement/* PlasmidElementSetTitleLink */.lV,
                ItemDescriptionComponent: PlasmidElement/* PlasmidElementSetDescription */.B8
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default */.Z, {
                spacing: {
                    pt: 10,
                    pb: 24
                },
                isBorderNone: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                        Tag: "div",
                        sx: {
                            fontSize: "l",
                            textAlign: "center"
                        },
                        children: [
                            "If you have suggestions for additional plasmids or plasmid collections, please",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                Component: Link/* default */.Z,
                                href: routes/* ROUTE_CONTACT_US */.ql,
                                children: "contact us"
                            }),
                            "."
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTryForFree/* default */.Z, {})
        ]
    });
};
PlasmidsHomePage.getInitialProps = sets_resolvers;
PlasmidsHomePage.services = {
    sgApiConn: (param)=>{
        let { sgApiConfig  } = param;
        return (0,sgApiConnection/* default */.Z)(__webpack_require__.g.fetch, sgApiConfig.baseUrl);
    },
    sgApiClient: (param)=>{
        let { sgApiConn  } = param;
        return (0,sgApiClient/* default */.Z)(sgApiConn);
    }
};
PlasmidsHomePage.postConditions = [
    [
        (param)=>{
            let { sets  } = param;
            return sets.length > 0;
        },
        (0,create_and_raise/* createAndRaise */.C)(ApplicationError/* default.NotFound */.Z.NotFound)
    ]
];
/* harmony default export */ var plasmids = ((0,pipe/* default */.Z)(PlasmidsHomePage, (0,i18/* WithLocale */._t)({
    resources: (plasmids_home_page_default())
}), WithConditions/* default */.ZP, (0,NextPageWithServices/* default */.Z)(services/* serviceCore */.T), AppError/* withErrorHandling */.b));


/***/ }),

/***/ 28207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B8": function() { return /* binding */ PlasmidElementSetDescription; },
/* harmony export */   "jM": function() { return /* binding */ PlasmidElementSectionBreadcrumbs; },
/* harmony export */   "lV": function() { return /* binding */ PlasmidElementSetTitleLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74229);
/* harmony import */ var _LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72989);






const PlasmidElementSectionBreadcrumbs = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: "py-5",
        isBorderNone: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingElement_SimpleSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Body */ .Z.Body, {
            children: children
        })
    });
};
PlasmidElementSectionBreadcrumbs.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const PlasmidElementSetTitleLink = (param)=>/*#__PURE__*/ {
    let { href , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        Tag: "div",
        sx: {
            fontSize: "l",
            fontColor: "2"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: href,
            ...props,
            children: children
        })
    });
};
PlasmidElementSetTitleLink.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string.isRequired,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node.isRequired
};
const PlasmidElementSetDescription = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        Tag: "div",
        ...props
    });
};


/***/ }),

/***/ 51192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UList_UList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/UList.js







const UListItem = (param)=>{
    let { bulletColor , size , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (0,classes/* classes */.S)("li", size && "text-".concat(size), bulletColor && "li--bullet-color-".concat(bulletColor), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
UListItem.propTypes = {
    size: props_sx/* fontSizePropTypes */.Gk,
    bulletColor: (0,prop_types.oneOf)([
        "orange",
        "dotmatics-7",
        "black--custom-1"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
const UList = (param)=>{
    let { type ="default" , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,classes/* classes */.S)("ul", "ul-".concat(type), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        children: children
    });
};
UList.propTypes = {
    type: (0,prop_types.oneOf)([
        "default",
        "pros",
        "cons"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
UList.Item = UListItem;
/* harmony default export */ var UList_UList = (UList);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js



/***/ }),

/***/ 15506:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_TITLE":"Plasmid Maps and Sequences","META_DESCRIPTION":"Download annotated SnapGene files for a variety of commonly used genes and plasmid vectors.","META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"article","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_ROBOTS":"index,follow","HERO_TITLE":"Plasmid Files","HERO_DESCRIPTION":"Download over 2,700 carefully annotated plasmid and sequence files including commonly used cloning vectors from all major suppliers"}');

/***/ }),

/***/ 73728:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_TITLE":"Plasmid Maps and Sequences","META_DESCRIPTION":"Download annotated SnapGene files for a variety of commonly used genes and plasmid vectors.","META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"article","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_ROBOTS":"index,follow","HERO_TITLE":"Plasmid Files","HERO_DESCRIPTION":"Download over 2,700 carefully annotated plasmid and sequence files including commonly used cloning vectors from all major suppliers"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,3308,2458,3918,4735,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(84670); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);